<template>
  <div class="mt-4 border">
    <template v-if="order.discounts && !order.discounts.length">
      <h4 class="mb-4">{{ "active_sale" | setText("Действующие акции") }}</h4>
      <ul>
        <li v-for="(variant, index) in order.promotions" :key="index">
          <h6 class="text-success mb-1">
            {{ "product" | setText("Товар") }} {{ index + 1 }} -
            {{ variant.name }}
          </h6>
          <div
            class="mb-1"
            :key="index2"
            v-for="(promotion, index2) in variant.variant.promotions"
          >
            <checkbox
              v-model="val"
              :value="`${index}-${variant['id']}-${promotion['id']}`"
              color="#2c75ff"
            >
              {{ promotion["name"] }}
            </checkbox>
          </div>
        </li>
      </ul>
      <h6 v-if="!order.promotions.length">
        {{ "no_sale" | setText("НЕТ АКТИВНЫХ АКЦИЙ") }}
      </h6>
      <button
        @click="setPromotion"
        v-if="order.promotions.length"
        class="btn btn-info mt-4 mb-3"
      >
        {{ "accept_sale" | setText(" Применить акции") }}
      </button>
    </template>

    <template v-else-if="order.discounts && order.discounts.length">
      <h4>{{ "accepted_sale" | setText("Вы применили акции:") }}</h4>
      <ul>
        <li v-for="(discount, index) in order.discounts" :key="index">
          <p>
            <span class="text-danger" v-if="discount.promotion">{{
              discount.promotion.name
            }}</span>
            <Br />
            <span class="text-success" v-if="discount.purchase">{{
              discount.purchase.name
            }}</span>
            <br />
            {{ "sale" | setText("Скидка:") }}
            {{ discount.discount | spaceBetweenNumber }} UZS
          </p>
          <hr />
        </li>
      </ul>
      <button
        @click="setPromotion(true)"
        v-if="order.promotions.length"
        class="btn btn-danger mb-3"
      >
        {{ "cancel_sale" | setText("Отменить акции") }}
      </button>
    </template>
    <Br />

    <discounts :order="order" />
  </div>
</template>
<script>
import { errorNotify, logger } from "../../../plugins/functions";
import Discounts from "./Discounts.vue";

export default {
  components: { Discounts },
  name: "products",
  props: {
    order: {
      default: null,
    },
    partner: {
      default: null,
    },
  },
  created() {},
  methods: {
    setPromotion(is_cancel = false) {
      if (is_cancel === true) {
        this.val = [];
      }

      this.loading = true;
      this.$http
        .put(`orders/${this.order.id}`, {
          is_promotion: true,
          promotions: this.val,
          partner_id: this.partner ? this.partner.id : null,
        })
        .then((response) => {
          this.data = response.data.data;
          this.$store.dispatch("setLastUpdate", new Date() * 1000 + 10);
        })
        .catch((error) => {
          errorNotify(error, this.notify);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  data() {
    return {
      val: [],
    };
  },
};
</script>
